// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__19R5c","inner":"Footer_inner__LUmW3"};